import { createAction, props } from '@ngrx/store';
import {
  BundleApplianceDetailsBasket,
  BundleApplianceDetails,
  RemoveBundleAppliancesAPIApplianceDetails,
} from '@sky/util-models';

export const removeAll = createAction('[Basket] Clear basket');

export const addDevicesToBasket = createAction(
  '[Basket] Add devices to basket',
  props<{ devices: BundleApplianceDetails[] }>()
);

export const addDeviceToBasketRedirect = createAction(
  '[Add Mobile] Add device to basket then redirect',
  props<{ devices: BundleApplianceDetails[] }>()
);

export const addDevicesToBasketSuccess = createAction(
  '[Basket] Devices added to basket successfully',
  props<{ devices: BundleApplianceDetailsBasket[] }>()
);

export const addDevicesToBasketFailure = createAction(
  '[Basket] Devices added to basket failed',
  props<{ error: Error }>()
);

export const deleteDevicesFromBasket = createAction(
  '[Basket] Delete devices from basket',
  props<{
    deviceIds: RemoveBundleAppliancesAPIApplianceDetails[];
    redirectBack?: boolean;
  }>()
);

export const deleteDevicesFromBasketSuccess = createAction(
  '[Basket] Devices deleted from basket successfully',
  props<{ deviceIds: string[]; redirectBack?: boolean }>()
);

export const deleteDevicesFromBasketFailure = createAction(
  '[Basket] Devices deleted from basket failed',
  props<{ error: Error }>()
);
